import { Component } from '@angular/core';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { HandlerService } from '../handler.service';
import { Platform } from '@angular/cdk/platform';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { SmsRetriever } from '@ionic-native/sms-retriever/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent {
  getId;
  serviceInc: boolean = false;
  proof: boolean;
  wallet: boolean = false;
  account: boolean;
  log: boolean = false;
  conf: boolean = true;
  url;
  numb;
  Proof;
  AdsProof;
  id;
  verified: boolean = false;
  name;
  housenbr;
  loader: boolean = true;
  street;
  city;
  region;
  state;
  getData;
  mob;
  zipcode;
  Proid;
  details;
  buttonView: boolean;
  place;
  locat;
  locationTrue;
  appHashString: any;
  otpClicked: boolean;
  viewage: boolean = false;
  locAd = []
  active: boolean = false;
  credits;
  discount: boolean = false;
  referralEmail: any;
  maxlength: any;
  referralName: any;
  referralContactNbr: any;
  numCd = ["+91"];
  linkshares: string;
  contact: string;
  refercode: any;
  rolelist: any[];
  schemename: any;
  constructor(private iab: InAppBrowser,private socialSharing: SocialSharing, public auth: AuthService, private router: Router, public handler: HandlerService, private platform: Platform,
    public service: ApiService, public location: LocationService, public smsRetriever: SmsRetriever) { }

  mobShare() {
    if (this.platform.ANDROID || this.platform.IOS) {
      var link = "https://play.google.com/store/apps/details?id=com.mctz.yb";
      this.socialSharing.share(link, null, null)
        .then(() => { return null; })
        .catch(() => { return null })
    }
  }

  ionViewWillEnter() {
    this.backUpLocation();
    this.otpClicked = true;
    this.active = false;
    this.id = localStorage.getItem('currentUserId');
    if (this.id) {
      this.getUser();
      this.buyMemb1();
    } else {
      this.loader = false;
    }
    if (this.auth.checkCapability('CUST')) {
      this.buttonView = false;
    } else {
      this.buttonView = true;
    }
    if (this.auth.checkCapability('SC') || this.auth.checkCapability('SP') || this.auth.checkCapability('FSA')) {
      this.viewage = true;
    } else {
      this.viewage = false;
    }

  }

  backUpLocation() {
    if (localStorage.getItem('place')) {
      this.place = JSON.parse(localStorage.getItem('place'));
      this.locationTrue = localStorage.getItem('locationTrue');
    }
    if (localStorage.getItem('location')) {
      this.locat = JSON.parse(localStorage.getItem('location'));
      this.locationTrue = localStorage.getItem('locationTrue');
    }
    if (localStorage.getItem('ads')) {
      this.locAd = JSON.parse(localStorage.getItem('ads'));

    }
  }

  editProfile() {
    if (!this.auth.loged()) {
      this.handler.res("Please Login To Update Your Profile")
    } else {
      this.router.navigate(['editcustomerProfile2/', this.id]);
    }
  }

  buyMemb1() {
    this.service.myMembership([]).subscribe((res: any) => {
      if (res) {
        this.schemename = res.membershipSchemeName;
        this.loader = false;
      } else {
        this.loader = false;
      }
    }, err => {
      this.loader = false;
    })
  }

  getUser() {
    // this.loader = true;
    this.service.getUserDetailsById(this.id).subscribe((res: any) => {
      if (res) {
        this.details = res;
        this.name = res.firstName;
        this.mob = res.contactNbrMob;
        if (res.userCredits.length > 0)
          this.credits = res.userCredits[0].creditPoints;
        else
          this.credits = 0;
        this.loader = false;
      } else {
        this.loader = false;
      }

    })
  }

  login() {
    localStorage.clear();
    sessionStorage.clear();
    if (this.place) {
      localStorage.setItem('place', JSON.stringify(this.place));
      localStorage.setItem('locationTrue', this.locationTrue);
    }
    if (this.locat) {
      localStorage.setItem('location', JSON.stringify(this.locat));
      localStorage.setItem('locationTrue', this.locationTrue);
    }
    this.serviceInc = true;
  }


  newUserorNot() {
    this.loader = true
    // let indboolean = true;
    // if (indboolean === true) {

    // } else {
    //   this.getHashCode()
    // }
    this.service.getnewUser("+91" + this.numb).subscribe((res: any) => {
      this.loader = false;
      console.log(res, "123")
      // this.handler.res("Referral Added Successfully");
    }, err => {
      this.handler.err(err);
      this.loader = false;
    })
  }

  getHashCode() {
    this.otpClicked = true;
    if (this.platform.ANDROID || this.platform.IOS) {
      this.smsRetriever.getAppHash()
        .then((res: any) => {
          this.appHashString = res;
          this.signIn();
        })
        .catch((error: any) => {
          this.signIn();
          console.error(error)
        });
    } else {
      this.signIn();
    }
  }


  signIn() {
    if (this.numb.length == 10) {
      var post = {
        "referralCode":this.refercode,
        "contactNbrMob": '+91' + this.numb,
        "orgCode": 'YB',
        "paless": true,
        "userType": 1,
        "roles": ['CUST'],
        "appId": 14,
        "addresses": [
          {
            "cityId": this.location.cityId,
            "stateId": this.location.stateId,
            "regionId": this.location.regionId,
            "street": this.location.street,
            "zipcode": this.location.zipcode,
            "lat": this.location.lat,
            "lon": this.location.lon,
            "type": 2,
            "orgId": 790
          }
        ]
      }
      if (this.platform.ANDROID || this.platform.IOS) {
        Object.assign(post, { "hashSms": this.appHashString })
      }
      this.service.customerLogin(post).subscribe((res: any) => {
        if (res) {
          if (this.platform.ANDROID || this.platform.IOS) {
            Object.assign(res, { "hashSms": this.appHashString })
          }
          // window['mock'] = res;
          sessionStorage.setItem('contactNbrMob', this.numb)
          this.handler.loginRes(res);
          this.serviceInc = false;
          this.numb = "";
          this.router.navigate(['/validateProfile'])
        }
      }, err => {
        this.handler.err(err);
        this.otpClicked = true;
      })
    } else {
      this.handler.phNumError("Please enter valid mobile number")
      this.otpClicked = true;
    }
  }
  closePop() {
    this.serviceInc = false;
    this.numb = "";
  }

  switchVendor() {
    localStorage.removeItem('capability')
    localStorage.removeItem('currentUserId')
    localStorage.removeItem('organizationId')
    localStorage.removeItem('capabilityOrg')
    localStorage.removeItem('hashKey')
    localStorage.removeItem('place')
    this.router.navigate(['/vendorLogin']);
  }
  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.handler.res('Logged Out Successfully !!')
    if (this.place) {
      localStorage.setItem('place', JSON.stringify(this.place));
      localStorage.setItem('locationTrue', this.locationTrue);
    }
    if (this.locat) {
      localStorage.setItem('location', JSON.stringify(this.locat));
      localStorage.setItem('locationTrue', this.locationTrue);
    }
    // if(this.locAd){
    //   localStorage.setItem('ads',JSON.stringify(this.locAd));
    // }   
    this.router.navigate(['/bookservice']);
    this.loader = false;
  }

  join() {
    localStorage.removeItem('capability')
    localStorage.removeItem('currentUserId')
    localStorage.removeItem('organizationId')
    localStorage.removeItem('capabilityOrg')
    localStorage.removeItem('hashKey')
    localStorage.removeItem('place')
    if (this.place) {
      localStorage.setItem('place', JSON.stringify(this.place));
      localStorage.setItem('locationTrue', this.locationTrue);
    }
    if (this.locat) {
      localStorage.setItem('location', JSON.stringify(this.locat));
      localStorage.setItem('locationTrue', this.locationTrue);
    }
    if (this.locAd) {
      localStorage.setItem('ads', JSON.stringify(this.locAd));
    }
    sessionStorage.clear();
    if (this.auth.loged()) {
      this.router.navigate(['/vendor-register1']);
    } else {
      this.router.navigate(['/vendor-register']);
    }
  }

  disc() {
    this.discount = true;
  }
  closeDic() {
    this.discount = false;
  }

  referFrnd() {
    console.log("check", localStorage.getItem('currentUserId'));
    if (localStorage.getItem('currentUserId') === null) {
      this.login();
    } else {
      this.disc();
    }

  }
  save1() {
    let x = this.referralContactNbr && this.referralName;
    if (!x) {
      this.handler.res("Please Enter Mobile Number,Name");
    }
    else {
      this.save();
    }
  }
  save() {
    this.loader = true
    var post;
    post = {
      newCustName: this.referralName,
      newCustPhnNbr: this.numCd + this.referralContactNbr,
    }
    this.service.shareReferrals(post).subscribe((res: any) => {
      this.loader = false;
      this.linkshares = res.message;
      this.handler.res("Referral Added Successfully");
      this.linkshare(res.newCustPhnNbr);
    }, err => {
      this.handler.err(err);
      this.loader = false;
    })
  }
  linkshare(data: any) {
    const numberW = data ? data : '8667744524';
    const message = encodeURIComponent(this.linkshares);
    if (this.platform.ANDROID || this.platform.IOS) {
      const whatsappUrl = `https://wa.me/${numberW}?text=${message}`;
      this.iab.create(whatsappUrl, '_system');
      console.log("WhatsApp link opened with InAppBrowser:", whatsappUrl);
    } else {
      const whatsappUrl = `https://wa.me/${numberW}?text=${message}`;
      window.open(whatsappUrl, '_blank');
      console.log("WhatsApp link opened:", whatsappUrl)
      console.log('This feature is only available on Android or iOS devices.');
    }
  }


  ionViewWillLeave() {
    this.otpClicked = true;
  }
  changeApp() {
    this.active = true
    sessionStorage.setItem('vendorApp', JSON.stringify(this.active))
    if (this.active) {
      if (this.auth.loged()) {
        if (this.auth.checkCapability('SC') && !this.auth.checkCapability('FSA') && !this.auth.checkCapability('SP')) {
          this.router.navigate(['/requests']);
        } else {
          this.router.navigate(['/vendor-request']);
        }
      } else {
        this.router.navigate(['/vendor-register'])
      }
    } else {
      if (this.auth.loged()) {
        this.router.navigate(['/bookservice1'])
      } else {
        this.router.navigate(['/bookservice'])
      }

    }
  }
  refer() {
    this.router.navigate(['/refer-dash'])
  }

}
